import {T_SHIRT_SUBCAT_IDS} from './constants/categoryConstants';
import {useSummerTShirtPromoTest} from './featureFlags';

export function isTshirtSummerPromoEligible(isSiteWideSearch, categoryId) {
  return !isSiteWideSearch && T_SHIRT_SUBCAT_IDS.includes(Number(categoryId));
}

export function useTshirtSummerPromo({categoryId, isSiteWideSearch}) {
  const {
    error: isSummerTShirtPromoTestError,
    isLoading: isSummerTShirtPromoTestLoading,
    variation: summerTShirtPromoTestVariation
  } = useSummerTShirtPromoTest();

  const tshirtSummerPromoEligible = isTshirtSummerPromoEligible(
    isSiteWideSearch,
    categoryId
  );

  const isEnabled =
    !isSummerTShirtPromoTestError && summerTShirtPromoTestVariation === 'test';

  return {
    isEligible: tshirtSummerPromoEligible,
    isEnabled,
    isLoading: isSummerTShirtPromoTestLoading
  };
}
